"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CAPTURE_SIZE = void 0;
/**
 * This size defines the dimensions currently produced by IKE Field captures.
 *
 * NOTE: Image dimensions should be read directly from images. Use this constant only when necessary.
 */
exports.DEFAULT_CAPTURE_SIZE = { width: 2836, height: 3781 };
//# sourceMappingURL=capture.js.map